module.exports = __webpack_public_path__ + "media/images/flags/4x3/gab-b5b9b62fadf5f1632aff5f072cd8fe79.svg";